import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import user from "./modules/user";
import file from "./modules/file";
import tagsView from "./modules/tagsView";
import permission from "./modules/permission";
import getters from "./getters";
import websocket from "./modules/websocket";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    file,
    permission,
    websocket,
    tagsView
  },
  getters
});

export default store;
